const dtGenerator = require('../../../../../components/dt/dt-generator')
const dtHandler = require('../../../../../components/dt/dt-handler')
const dtSearchHandler = require('../../../../../components/dt/dt-search-handler')
const debounce = require('../../../../../js-handler/debounce')
const inf = require('../../../../../js-network/inf')
const dbRequest = require('../../../../../js-network/db-request')
const { organizeRow } = require('./purchaseDeleted-dt-handler')

const htmlDt = {}
let HTMLwasSelected = false

const tableDetail = {
  entity: 'purchaseDeleted',
  dest: 'purchaseDeleted',
  tdDataDetail: `data-detail='{ "click": [{"dest":"ripple"},{"dest":"purchaseDeleted","elem":"fullcont","id":"purchaseDeleted-fullcont","act":"selectOne","entity":"purchaseDeleted","dbid":"#dbid"}] }'`,
  filter: {
    mainFilterFields: ['purchase.code', 'provider.name', 'purchase.reference_number', 'item.name', 'item.brand'],
    mainFilterValues: ['', '', '', '', ''],
    andFilterFields: []
  }
}

function HTMLselect() {
  dtHandler.HTMLselect('purchaseDeleted-dt', htmlDt, organizeRow, tableDetail)
  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()
  const actions = { select, searching, loadMore, th }
  if (actions[detail.act]) actions[detail.act](detail)
}

function searching(detail) {
  if (detail.ev && detail.ev.target) detail.ev.target.classList.add('searching')
  if (dtSearchHandler.searchCancel(htmlDt)) return
  debounce.start(() => {
    dtSearchHandler.cleanDt(htmlDt)
    select(detail, true).finally(() => detail.ev && detail.ev.target && detail.ev.target.classList.remove('searching'))
  })
}

function loadMore(detail) {
  if (dtSearchHandler.isDisableFooter(detail)) return
  dtSearchHandler.increaseFooter(htmlDt)
  select(detail, false)
}

function th(detail) {
  dtSearchHandler.cleanDt(htmlDt)
  select(detail, true)
}

async function select(detail, cleanTable = true) {
  inf.toSelect(detail, htmlDt)
  htmlDt.entityDt.classList.add('dt-loading')
  try {
    const result = await dbRequest.start(detail, 'server/php/sql/select.php')
    if (result.status !== 'ok') throw result
    dtGenerator.addBody(organizeRow(result.data || []), htmlDt, cleanTable)
    hideMultipleSelection()
    dtSearchHandler.updateFooter(htmlDt, result.availableRowsWithFilters)
  } finally {
    htmlDt.entityDt.classList.remove('dt-loading')
  }
}

function hideMultipleSelection() {
  htmlDt.entityDt.querySelectorAll('th:first-child, td:first-child').forEach(cell => {
    cell.style.display = 'none'
  })
}

